export default "__VITE_ASSET__BaTfI_FN__"